<template>
  <div>
    {{ translate.result.inelegible.instruction }}
    <br />
    <br />
    {{ translate.result.inelegible.whatsapp }}
  </div>
</template>

<script>
export default {
  name: 'inelegible-result',
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>
